import * as React from 'react';

import { PageTitleBar } from 'components';

const ProductsReportHeader = () => (
  <PageTitleBar showBackButton={false} headerTitle='گزارش‌ محصول‌ها' />
);

export { ProductsReportHeader };
